import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimeLoaderComponent } from './anime-loader/anime-loader.component';
import { LottieModule } from "ngx-lottie";
import player from "lottie-web";
import { ToggleButtonComponent } from './toggle-button/toggle-button.component';
import { FormsModule } from '@angular/forms';  
import { MatCardModule } from '@angular/material/card';
import { ImportExcelComponent } from './import-excel/import-excel.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { SearchDropdownComponent } from './search-dropdown/search-dropdown.component';
import { ConstantMaterialModule } from 'src/app/material_module/constant-material.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';

export function playerFactory() {
  return player;
}



@NgModule({
  declarations: [
    AnimeLoaderComponent,
    ToggleButtonComponent,
    ImportExcelComponent,
    SearchDropdownComponent
  ],
  imports: [
    ConstantMaterialModule,
    CommonModule,
    LottieModule.forRoot({ player: playerFactory }),
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule
  ],
  exports:[
    AnimeLoaderComponent,
    ToggleButtonComponent,
    SearchDropdownComponent
  ]
})
export class CrmCommonModule { }
